/* eslint-disable parog-web/no-glint-expect-error-directive */
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SemeiaSessionService from 'parog-web/services/session';
import DatePicker from '../../changeset/date-picker';
interface Signature {
  Args: {
    changeset?: unknown;
  };
}

export default class IntroductionForm extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  <template>
    {{#if this.session.patient}}
      <p>
        Votre médecin souhaiterait connaître vos résultats d'analyses
        biologiques. Pourriez-vous prendre quelques minutes pour reporter les
        valeurs indiquées sur les résultats transmis par votre laboratoire
        d'analyse.
      </p>

      <p>
        <LinkTo
          @route='patient-web.protected.dashboard.article'
          @model='nephro-transplant-bio-exams'
          data-test-link-to-education-sheet
        >
          Cliquez ici pour en savoir plus sur les examens biologiques.
        </LinkTo>
      </p>

      <div class='ui semeia-form warning message'>
        Ne remplissez que les valeurs demandées par votre médecin.
      </div>

      <div class='ui divider hidden'></div>
    {{/if}}

    <div class='field'>
      <DatePicker
        @labelName='Date à laquelle les analyses ont été effectuées'
        @propertyName='occurredAt'
        {{! @glint-expect-error }}
        @changeset={{@changeset}}
      />
    </div>

    <div class='ui divider hidden'></div>
  </template>
}
